export default "__VITE_ASSET__v4XWZPXp__"